export enum BulkTaskStatusEnum {
  AwaitingProcessing = 1,
  Processing = 2,
  ProcessedWithIssues = 3,
  ProcessedWithoutIssues = 4,
  ProcessingFailure = 5,
}
